import styled from "styled-components";
import breakpoints from "../../../styles/breakpoints";
import { fonts } from "../../../styles/variables";
import OffCanvasTrayHeaderTitle from "../../atoms/OffCanvasTrayHeaderTitle";
import OffCanvasTrayHeader from "../../molecules/OffCanvasTrayHeader";
import fineTuneImage2 from "../../../assets/images/elements/fine-tune-2.svg";

export const Text = styled.div`
  margin-bottom: 32px;
  line-height: 20px;
  font-weight: 400;
`;

export const BackgroundImage = styled.img.attrs(() => ({
  src: fineTuneImage2,
}))`
  width: 249px;
  height: 218px;
  position: absolute;
  bottom: 120px;
  right: 40px;

  ${breakpoints.smDown} {
    text-align: center;
    padding: 0px 20px;
    position: relative;
    width: 207px;
    height: 181px;
    right: 0;
    bottom: 0;
  }
`;

export const TrayContentContainer = styled.div``;

export const BackgroundImageContainer = styled.div`
  ${breakpoints.smDown} {
    text-align: right;
  }
`;

export const BottleWrapper = styled.div`
  width: 191px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;

export const BottleImageWrapper = styled.div<{ backgroundColor: string }>`
  width: 100%;
  height: 171px;
  background: ${(props) => props.backgroundColor};
  display: flex;
  justify-content: center;
`;

export const BottleImage = styled.img`
  transform: rotate(90deg);
  height: 169px;
`;

export const BottleName = styled.div`
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 18px;
  line-height: 19px;
  margin-top: 5px;
`;

export const StyledOffCanvasTrayHeaderTitle = styled(OffCanvasTrayHeaderTitle)`
  ${breakpoints.smDown} {
    margin-top: 12px;
    font-size: 45px;
  }
`;

export const StyledOffCanvasTrayHeader = styled(OffCanvasTrayHeader)<{ noBottomSpacing?: boolean }>`
  ${breakpoints.smDown} {
    text-align: left;
    padding-bottom: ${(props) => (props.noBottomSpacing ? 0 : "inherit")};
    & > button {
      left: 0;
      top: 12px;
      position: relative;
    }
  }
`;
